module.exports = __webpack_public_path__ + "static/media/warning.ccca1e55.svg";